<template>
  <div>
    <div class="prompt">
      <img src="./../../assets/images/img2.png" class="ig">
      <span class="s">恭喜各位本月排名前十，感谢您为公司的付出和努力，加油！</span>
    </div>
    <div class="cut" style="display: flex;justify-content: space-between;align-items: center">
       <div class="grid-content bg-purple">
          <span class="el-icon-arrow-left btn1" @click="addBtn()"></span>
        </div>
        <div class="grid-content bg-purple" style="text-align: center;">
          <span>
          <span class="cenBox">
            <span>{{ats3}}年第{{ats1}}月</span>
          </span>
        </span>
        </div>
        <div class="grid-content bg-purple">
          <span class="el-icon-arrow-right btn2" @click="addBtn1()"></span>
        </div>

    </div>

    <div class="herBox">
      <div style="width: 3px;height: 13px;background-color: #419DE7;margin-left: 20px"></div>
      <span class="ts">部门销售排行TOP10</span>
    </div>



    <div v-for="(list,value) in list1" style="display: flex;padding: 20px;border-bottom: 1px solid #e8e8e8;margin: 0px 15px">
      <div class="grid-content bg-purple t1">
        <div v-if="value=='0'">
          <img src="./../../assets/images/huangguan.png" class="ig2" >
          <span class="t2">{{value+1}}</span>
        </div>
        <div v-else-if="value=='1'">
          <img src="./../../assets/images/huangguan2.png" class="ig2" >
          <span class="t3">{{value+1}}</span>
        </div>
        <div v-else-if="value=='2'">
          <img src="./../../assets/images/huangguan3.png" class="ig2" >
          <span class="t4">{{value+1}}</span></div>
        <div v-else><span class="ts1">{{value+1}}</span></div>
      </div>
     <div class="grid-content bg-purple-light"style="margin-left: 10px">
        <span class="t5">{{list.salesman_name}}</span>
      </div>
      <div class="grid-content bg-purple" style="position: absolute;right: 20px">
        <span class="t6">{{list.amount}}</span>
      </div>

    </div>
  </div>
</template>

<script>
import http from "../../APIService/http";
export default {
  name: "loMonth",
  props:{
    ats:{
      type: String
    },
    ats1:{
      type: String
    },
    ats2:{
      type: String
    },
    ats3:{
      type: String
    }
  },
  data(){
    return{
      list1:[]
    }
  },
  methods:{
    nv(){
      let forms={
        tenant_id:this.ats,
        dataStr:this.ats1,
        type:this.ats2,
        year:this.ats3
      }
      let that = this
      http.post('/wapi/gkGetFeedback/GkSalesmanRank',forms).then(function (res){
        that.list1 = res.data.data;
        console.log(that.list1)
      })
    },
    addBtn(){
      if(parseInt(this.ats1) >1){
        this.ats1--;
        this.nv();
      }else {
        this.ats1=12;
        this.ats3--;
        this.nv()
      }
    },
    addBtn1(){
      if(parseInt(this.ats1)<12){
        this.ats1++;
        this.nv()
      }else {
        this.ats1 = 1;
        this.ats3 ++;
        this.nv()
      }
    }
  },
  created() {
    this.nv();
  }
}
</script>

<style scoped>
  .ig2{
    width: 26px;
    height: 15px;
    position: absolute;
    margin-top: -16px;
    margin-left: -6px;
  }
  .ts1{
    padding: 10px 17px;
    background-color: #F2F8FC;
    color: #B3C5D3;
    border-radius: 50%;
  }
  .t6{
    font-size: 15px;
    float: left;
  }
  .t4{
    padding: 10px 17px;
    background-color: #EC9F54;
    color: white;
    border-radius: 50%;
  }
  .t3{
    padding: 10px 17px;
    background-color: #99ADCB;
    color: white;
    border-radius: 50%;
  }
  .t2{
    padding: 10px 17px;
    background-color: #F6DE6B;
    color: white;
    border-radius: 50%;
  }
  .t1{
    text-align: center;
  }
  .btn1{
    float: left;
  }
  .btn2{
    float: right;
  }
  .ig{
    width: 11px;
    height: 11px;
  }
  .prompt{
    width: 100%;
    height: 26px;
    line-height: 26px;
    background: rgba(255, 153, 1, 0.15);
    color: #FF9901;
    font-size: 11px;
    text-align: center;
  }
  .cut{
    margin:10px 20px;
  }
  .cenBox{
    color: #FF9901;
    font-size: 16px;
  }
  .ts{
    color: #419DE7;
    font-size: 14px;
    margin-left: 30px;
    margin-top: -14px;
    position: absolute;
  }
  .herBox{
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/gkReport/loMonth.vue